import { render, staticRenderFns } from "./WritingDetailTR.vue?vue&type=template&id=472c8999&scoped=true&"
import script from "./WritingDetailTR.vue?vue&type=script&lang=js&"
export * from "./WritingDetailTR.vue?vue&type=script&lang=js&"
import style0 from "./WritingDetailTR.vue?vue&type=style&index=0&id=472c8999&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c8999",
  null
  
)

export default component.exports